

















































import Vue from 'vue'
import Component from 'vue-class-component'
import { Getter, Action } from 'vuex-class'
import { mapGetters } from 'vuex'

import DigitalCurrency4PriceLabel from '../../../../../../html-components-type-1-basic/basic-type-2-digital-currency/digital-currency-4-price-label.vue'
import DigitalCurrency6AccountUserProfilePicture from '../../../../../../html-components-type-1-basic/basic-type-2-digital-currency/digital-currency-6-account-user-profile-picture.vue'
import UserInterface3ErrorMessage from '../../../../../../html-components-type-1-basic/basic-type-4-user-interface/user-interface-3-error-message.vue'



const namespace = 'digitalCurrency'

@Component({
  components: {
    DigitalCurrency4PriceLabel,
    DigitalCurrency6AccountUserProfilePicture,
    UserInterface3ErrorMessage
  },
  computed: mapGetters(['getActiveDigitalCurrencyAccount'])
})
class AccountInformationSettings2ActiveAccountSettings extends Vue {

  @Getter('getActiveDigitalCurrencyAccount', { namespace }) getActiveDigitalCurrencyAccount?: any
  @Getter('getServiceAccountDigitalCurrencyAccountList', { namespace }) getServiceAccountDigitalCurrencyAccountList: any

  @Action('createDigitalCurrencyAccount', { namespace }) createDigitalCurrencyAccount?: any
  @Action('updateServiceAccountActiveDigitalCurrencyAccountId', { namespace }) updateServiceAccountActiveDigitalCurrencyAccountId?: any

  showErrorMessage: boolean = false
  errorMessage: string = ''

  selectedDigitalCurrencyAccountList: any[] = []

  digitalCurrencyAccountTableHeader: any[] = [
    { align: 'start', value: 'accountProfilePictureUrl', sortable: false },
    { text: 'Account Name', value: 'accountName' },
    { text: 'Account Balance', value: 'accountCurrencyAmount' },
    { text: 'Set Active', value: 'activateAccount', sortable: false }
  ]

  createAccountPromise: Promise<any> | null = null

  isSelectedAccount (account: any): boolean {
    if (!this.getActiveDigitalCurrencyAccount) {
      return false
    }
    return this.getActiveDigitalCurrencyAccount.accountId === account.accountId
  }

  selectActiveDigitalCurrencyAccount (account: any) {
    // Vue.set(this.selectedDigitalCurrencyAccountList, 0, account)
    this.updateServiceAccountActiveDigitalCurrencyAccountId(account.accountId)
  }

  createAccount () {
    if (this.createAccountPromise) {
      return
    }

    this.createAccountPromise = this.createDigitalCurrencyAccount()
    .then(() => {
      this.createAccountPromise = null
    }).catch((errorMessage: any) => {
      this.errorMessage = errorMessage
      this.showErrorMessage = true
      this.createAccountPromise = null
    })
  }

  get selectedDigitalCurrencyAccount () {
    return [this.getActiveDigitalCurrencyAccount]
  }

  set selectedDigitalCurrencyAccount (item: any) {
    this.updateServiceAccountActiveDigitalCurrencyAccountId(item[0].accountId)
  }
}

export default AccountInformationSettings2ActiveAccountSettings

